import React from 'react';

import { ViewEntityHeader } from 'components/entityViewer/ViewEntityHeader';
import {
    getTransferNumberDisplay,
    getTransferStatusDisplay,
} from 'components/warehouse/components/fcTransfers/fcTransferDisplayUtils';
import { Badge } from 'shadcn/components/ui/Badge';

/**
 * Accept Transfer page header: back link, title, and transfer status badge (no transfer-level Save action).
 *
 * @param {Object} props
 * @param {string | import('react-router-dom').To} props.backHref
 * @param {string} [props.backLabel='Back to FC Transfers']
 * @param {Object} [props.backLinkProps]
 * @param {Record<string, unknown> | null} [props.transfer=null]
 */
export function AcceptTransferHeader({ backHref, backLabel = 'Back to FC Transfers', backLinkProps, transfer = null }) {
    const transferNumber = getTransferNumberDisplay(transfer);
    const statusLabel = getTransferStatusDisplay(transfer);

    const entityIdentificationComponent = (
        <div className="flex w-full min-w-0 flex-wrap items-start gap-3 lg:items-center">
            <div className="flex min-w-0 flex-wrap items-center gap-3">
                <h1 className="text-2xl font-semibold tracking-tight text-foreground">
                    Accept Transfer # {transferNumber}
                </h1>
                <Badge variant="outline" className="shrink-0 font-normal">
                    {statusLabel}
                </Badge>
            </div>
        </div>
    );

    return (
        <ViewEntityHeader
            backHref={backHref}
            backLabel={backLabel}
            backLinkProps={backLinkProps}
            entityIdentificationComponent={entityIdentificationComponent}
        />
    );
}

AcceptTransferHeader.displayName = 'AcceptTransferHeader';
